import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/pages/index/our_expertise/nagase-logo-p.jpg")